import * as React from "react";
const SvgShort = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L9 9M9 9L9 3M9 9L3 9", stroke: "var(--color-red-500)", strokeLinecap: "round" }));
export default SvgShort;
